import React from 'react';
import { classList } from 'utils/componentsCommon';

const HeroToast = ({ children, figure, animation, className, onClickMethod, accentColor, ...props }) => {
    const classNames = classList('heroToast', animation ? 'animation' : '', className);
    const shadowColorValue = accentColor ? `20px -20px 0 ${accentColor}` : '';

    return (
        <div className={ classNames } { ...props }>
            <div>
                <div onClick={ onClickMethod } className={ onClickMethod != null ? 'click' : '' } style={{ boxShadow: shadowColorValue }}>
                    <div>{ children }</div>
                    { figure && <img src={ figure } /> }
                </div>
            </div>
        </div>
    );
};

export default HeroToast;
